import { IonSpinner } from "@ionic/react";
import RightArrowThin from "assets/images/icon/svg/RightArrowThin";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import Accounts from "services/Accounts";
import { getSelectedDate } from "redux/container/dashboardSlice";

export default function EmployeeHoursChart() {
	const [employeeHoursData, setEmployeeHoursData] = useState([]);
	const dateFormat = useSelector((state) => state.date.format);
	const [loader, setLoader] = useState(false);
	const screenSize = window.matchMedia("(max-width: 400px)")?.matches;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const employeeRevenueChartData = {
		labels: employeeHoursData?.map((item) => item.display_name),
		datasets: [
			{
				label: "Hours",
				data: employeeHoursData?.map((item) => item?.working_hours),
				backgroundColor: "#00B224",
			},
		],
	};
	moment.updateLocale("en", {
		week: {
			dow: 1,
		},
	});
	const startDay = moment().startOf("week").format("YYYY-MM-DD");
	const endDay = moment().format("YYYY-MM-DD");

	const getEmployeeHoursData = async () => {
		setLoader(true);
		let response = await Accounts.getEmployeeHoursData(startDay, endDay);
		if (response.success) {
			setLoader(false);
			setEmployeeHoursData(response?.results);
		} else {
			setLoader(false);
		}
	};

	useEffect(() => {
		getEmployeeHoursData();
	}, []);

	const employeeHoursBarRef = useRef();
	const barClickHandler = (event, type) => {
		const chartConfigs = {
			employeeHours: {
				ref: employeeHoursBarRef,
				data: employeeHoursData,
				path: "employee-hours-parts",
			},
		};

		const config = chartConfigs[type];
		if (!config) return;

		const clickedElement = getElementAtEvent(config.ref.current, event)[0];
		if (!clickedElement) return;

		const elementIndex = clickedElement.index;
		const value = config.data[elementIndex];
		if (!value) return;

		const startDay = moment().subtract(7, "days").format("YYYY-MM-DD");
		const endDay = moment().format("YYYY-MM-DD");

		const dateTime = {
			start: startDay,
			end: endDay,
			level: "thisWeek",
			userId: value?.user_id,
		};

		dispatch(getSelectedDate(dateTime));
		navigate(
			`/${config.path}?state=${startDay}&end=${endDay}&userId=${value?.user_id}&userName=${value?.display_name}`
		);
	};

	return (
		<div className='relative py-2'>
			<div className='chart-wrapper relative mb-4'>
				{loader ? (
					<div className='absolute h-full w-full flex justify-center items-center left-[7%] top-[5%]'>
						<IonSpinner name='circular'></IonSpinner>
					</div>
				) : undefined}

				<div className='px-2 pb-4 flex justify-between items-center'>
					<h4 className='font-bold text-18 sm:text-20 text-black-1000'>
					WorkTime Leaderboard
					</h4>
					<h3 className='font-bold text-black-500 text-14'>
						Weekly
					</h3>
				</div>

				<div
					className='flex justify-center'
					style={{
						width: "100%",
						maxWidth: "768px",
						height: screenSize && "250px",
					}}>
					<Bar
						ref={employeeHoursBarRef}
						data={employeeRevenueChartData}
						onClick={(e) => barClickHandler(e, "employeeHours")}
						options={{
							scales: {
								x: {
									beginAtZero: true,
								},
								y: {},
							},
							barPercentage: 0.7,
							plugins: {
								legend: false,
							},
							maintainAspectRatio: false,
						}}
					/>
				</div>
			</div>
		</div>
	);
}
